import AccessibilityHelper from '../../00_utilities/helpers/AccessibilityHelper';
import Counter from '../Counter';

class Teaser {
    constructor(elem) {
        this.elem = elem;
        this.counterElements = this.elem.querySelectorAll('[data-count-to]');
    }

    init() {
        if (this.counterElements.length) {
            const hasOSReducedMotion = AccessibilityHelper.prefersReducedMotion();
            if (!hasOSReducedMotion) {
                this.initializeCounter();
            }
        }

        if (this.elem.classList.contains('teaser--sharer')) {
            this.initializeSharing();
        }
    }

    initializeCounter() {
        const header = document.querySelector('.page-header');
        const { height: headerHeight } = header.getBoundingClientRect();

        const options = {
            rootMargin: `${headerHeight * -1}px 0px ${headerHeight * -1}px 0px`,
            threshold: [1],
        };
        const observer = new IntersectionObserver((entries, self) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.initializeCounterAnimation();
                    self.unobserve(entry.target);
                }
            });
        }, options);

        observer.observe(this.elem);
    }

    initializeCounterAnimation() {
        this.counterElements.forEach((element) => {
            const numbers = Counter.prepareNumbers(element);
            if (numbers) {
                const { countTo, numberDecimal, useGroupingFormat } = numbers;
                Counter.countUp(element, countTo, numberDecimal, useGroupingFormat);
            }
        });
    }

    initializeSharing() {
        const sharerToggle = this.elem.querySelector('.teaser__share-toggle');

        sharerToggle.addEventListener('change', (event) => {
            if (event.currentTarget.checked) {
                const siblings = this.getSiblings();
                siblings.forEach((sibling) => {
                    const siblingToggle = sibling.querySelector('.teaser__share-toggle');
                    if (siblingToggle) {
                        siblingToggle.checked = false;
                    }
                });
            }
        });
    }

    getSiblings(element = this.elem) {
        return Array.prototype.filter.call(element.parentNode.children, (sibling) => {
            return sibling !== element;
        });
    }
}

export default Teaser;
